import { useContext } from 'react'
import { RootContext } from '../context/context'

export const useRootController = () => {
  return useContext(RootContext)
}

export const useControllers = () => {
  return useRootController().children
}